import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

const MatchCompletionTrendChart = ({ data = [] }) => {
  const hasData = data.some((row) => row.leagueMatches > 0 || row.tournamentGames > 0);

  if (!hasData) {
    return (
      <div className="h-72 flex items-center justify-center text-sm text-muted-foreground">
        No completed matches in the last 6 months
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={288}>
      <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
        <XAxis dataKey="month" tick={{ fontSize: 12 }} stroke="var(--color-muted-foreground)" />
        <YAxis allowDecimals={false} tick={{ fontSize: 12 }} stroke="var(--color-muted-foreground)" />
        <Tooltip
          contentStyle={{
            backgroundColor: 'var(--color-card)',
            border: '1px solid var(--color-border)',
            borderRadius: '8px',
          }}
        />
        <Legend />
        <Bar dataKey="leagueMatches" name="League Matches" fill="#0D3B7A" radius={[4, 4, 0, 0]} />
        <Bar dataKey="tournamentGames" name="Tournament Games" fill="#0277BD" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default MatchCompletionTrendChart;
